
class ApiError extends Error {
	constructor (err) {
		const { code, details, message, name, type } = err
		super(message)
		this.name = name
		this.type = type
		this.details = details
		this.message = message
		this.code = code
		console.error('ApiError', this.message)
		// Parse the error
		this.parse()
	}

	parse () {
		switch (this.code) {
		default:
			break
		}
	}

	unknownError () {
		this.message = 'Unknown error'
	}

	getMessage () {
		return this.message
	}
}

export default ApiError
